(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "normalizr", "@braindate/util/lib/assert", "./braindateAssertions", "../schema"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("normalizr"), require("@braindate/util/lib/assert"), require("./braindateAssertions"), require("../schema"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.normalizr, global.assert, global.braindateAssertions, global.schema);
    global.braindateNormalization = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _normalizr, _assert, _braindateAssertions, _schema) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.hydrateBraindate = hydrateBraindate;
  _exports.hydrateBraindates = hydrateBraindates;
  _exports.normalizeBraindate = normalizeBraindate;
  _exports.normalizeBraindates = normalizeBraindates;

  /**
   * Normalize a braindate
   * @param   {Braindate} braindate - Braindate to normalize
   * @returns {number} data.result - Id of the braindate
   * @returns {NormalizedData<number>} data.entities - Normalized data entities
   *
   * @throws Will throw an exception if parameter is not an object
   */
  function normalizeBraindate(braindate) {
    (0, _braindateAssertions.assertBraindate)(braindate);
    return (0, _normalizr.normalize)(braindate, _schema.braindateSchema);
  }

  /**
   * Normalize braindates
   * @param   {Array<Braindate>} braindates - Braindates to normalize
   * @returns {Array<number>} data.result - Ids of the braindates
   * @returns {NormalizedData<Array<number>>} data.entities - Normalized data
   * entities
   *
   * @throws Will throw an exception if parameter is not an array
   */
  function normalizeBraindates(braindates) {
    (0, _assert.assertArray)(braindates, "braindates");
    return (0, _normalizr.normalize)(braindates, _schema.braindatesSchema);
  }

  /**
   * Denormalize a braindate
   * @param   {number} id - Id of the braindate
   * @param   {Entities} entities - Normalized data entities
   * @returns {Braindate} Denormalized braindate
   *
   * @throws Will throw an exception if parameters are invalid
   */
  function hydrateBraindate(id, entities) {
    (0, _assert.assertNumber)(id, "id");
    (0, _assert.assertObject)(entities, "entities");
    return (0, _normalizr.denormalize)(id, _schema.braindateSchema, entities);
  }

  /**
   * Denormalize braindates
   * @param   {Array<number>} ids - Ids of the braindates
   * @param   {Entities} entities - Normalized data entities
   * @returns {Array<Braindate>} Denormalized braindates
   *
   * @throws Will throw an exception if parameters are invalid
   */
  function hydrateBraindates(ids, entities) {
    (0, _assert.assertArray)(ids, "ids");
    (0, _assert.assertObject)(entities, "entities");
    return (0, _normalizr.denormalize)(ids, _schema.braindatesSchema, entities);
  }
});